import React, { useState, useRef, useEffect } from 'react';
import LeftArrow from 'assets/svg/left-arrow.svg';

interface FaqSectionProps {
  title: string;
  description: string;
  faqs: Faqs[];
}

interface Faqs {
  id: string;
  question: string;
  answer: {
    data: {
      answer: string;
    };
  };
}
export const FaqSection = ({ title, description, faqs }: FaqSectionProps) => {
  const [height, setHeight] = useState('0px');
  const contentRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  useEffect(() => {
    if (contentRef.current) {
      const { scrollHeight } = contentRef.current;
      setHeight(`${scrollHeight}px`);
    }
  }, [activeIndex]);
  return (
    <div className="faq">
      {title && <h2 className="faq-title">{title}</h2>}
      {description && <p className="faq-description">{description}</p>}
      <div className="faq-accordion">
        {faqs &&
          faqs.length > 0 &&
          faqs.map((el, index) => {
            const isActive = activeIndex === index;
            const buttonId = `accordion-button-${index}`;
            const panelId = `accordion-panel-${index}`;
            const answer = el?.answer?.data?.answer;
            return (
              <div
                key={el.id}
                className={`faq-accordion-item ${isActive ? 'active' : ''}`}
              >
                <h3 className="faq-accordion-item-question">
                  <button
                    type="button"
                    aria-expanded={isActive}
                    aria-controls={panelId}
                    id={buttonId}
                    className=""
                    onClick={() => setActiveIndex(isActive ? null : index)}
                  >
                    <span className="">{el.question}</span>
                    <span className="faq-accordion-item-question-icon">
                      <LeftArrow />
                    </span>
                  </button>
                </h3>
                <div
                  id={panelId}
                  role="region"
                  aria-labelledby={buttonId}
                  className={`faq-accordion-item-answer ${
                    isActive ? 'active' : ''
                  }`}
                  style={{ height: isActive ? height : '0px' }}
                >
                  <div
                    className="faq-accordion-item-answer-container"
                    ref={isActive ? contentRef : null}
                  >
                    {answer && <p className="">{answer}</p>}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div />
    </div>
  );
};
